import { baseApi } from '../../api/baseApi';
export const pinServiceApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        checkHasCredentials: builder.query({
            query: ({ accountId, partyId }) => {
                let url = `/v1/party-service/has-credentials?accountId=${accountId}`;
                if (partyId) {
                    url += `&partyId=${partyId}`;
                }
                return { url, forceAccountantApiBaseUrl: true };
            },
            transformResponse: (response) => {
                if (!response)
                    return false;
                const typedResponse = response;
                const result = typedResponse?.result ?? false;
                return result;
            },
        }),
        createPinCredentials: builder.mutation({
            query: body => ({
                url: '/v1/party-service/credentials',
                method: 'POST',
                body,
                forceAccountantApiBaseUrl: true,
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object' && 'status' in response) {
                    const status = response.status;
                    if (status === 201) {
                        return;
                    }
                }
            },
        }),
    }),
    overrideExisting: false,
});
export const { useCheckHasCredentialsQuery, useLazyCheckHasCredentialsQuery, useCreatePinCredentialsMutation } = pinServiceApi;
